// 身份证
function verify_identity($str) {
	let reg = /(^([\d]{15}|[\d]{18}|[\d]{17}x|[\d]{17}X)$)/
	// let reg = /(^[1-9]\\d{5}(18|19|20)\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}$)/
	return reg.test($str)
}
// 邮箱
function verify_email($str) {
	let reg = /^[_\.0-9a-z-]+@([0-9a-z][0-9a-z-]+\.)+[a-z]{2,4}$/
	return reg.test($str)
}
// 邮编
function verify_zip($str) {
	let reg = /^[1-9]\d{5}$/
	return reg.test($str)
}
// 手机号
function verify_phone($str) {
	let reg = /^1[3456789]\d{9}$/
	return reg.test($str)
}
// 密码（登录、管理端等通用：历史规则，勿改以免影响存量流程）
function verify_password($str) {
	let reg = /^(\w){5,18}$/
	return reg.test($str)
}

/**
 * 用户端「注册 / 找回密码」用户名：仅允许英文字母 a-z / A-Z（大小写敏感），最长 14 位。
 * 禁止数字、空格、符号、下划线、横杠、汉字等。
 * @returns {string} 校验失败时的提示文案；通过则返回空字符串
 */
function getRegisterUsernameError(str) {
	const s = str == null ? '' : String(str)
	if (!s) return ''
	if (s.length > 14) return '用户名最长为 14 个英文字母'
	if (!/^[a-zA-Z]+$/.test(s)) {
		return '用户名仅能使用英文字母（a–z、A–Z，区分大小写），不可含数字、空格、符号、下划线、横杠、汉字等'
	}
	return ''
}

/**
 * 用户端「注册 / 找回密码」密码（仿百度强规则）：长度 8–32；
 * 字符集仅限大小写字母、数字、符号 !@#$%^&*；禁止空格、汉字及其它符号。
 * 复杂度：大写、小写、数字、符号四类中至少满足两类。
 * @returns {string} 校验失败时的提示文案；通过则返回空字符串
 */
function getRegisterPasswordError(str) {
	const s = str == null ? '' : String(str)
	if (!s) return ''
	if (s.length < 8 || s.length > 32) return '密码长度须为 8–32 位'
	if (!/^[A-Za-z0-9!@#$%^&*]+$/.test(s)) {
		return '密码仅可使用字母、数字及符号 !@#$%^&*，不可含空格、汉字或其它特殊符号'
	}
	const hasUpper = /[A-Z]/.test(s)
	const hasLower = /[a-z]/.test(s)
	const hasDigit = /[0-9]/.test(s)
	const hasSymbol = /[!@#$%^&*]/.test(s)
	const kindCount = [hasUpper, hasLower, hasDigit, hasSymbol].filter(Boolean).length
	if (kindCount < 2) {
		return '密码须至少包含以下四类中的两类：大写字母、小写字母、数字、符号（!@#$%^&*）'
	}
	return ''
}

export default {
	verify_identity: verify_identity,
	verify_email: verify_email,
	verify_zip: verify_zip,
	verify_phone: verify_phone,
	verify_password: verify_password,
	getRegisterUsernameError: getRegisterUsernameError,
	getRegisterPasswordError: getRegisterPasswordError
}
